import * as React from "react";
import {connect} from "react-redux";
import SpecialItemComponent from "../components/SpecialItemComponent";
import {selectorLoadingSpecial} from "../selectors";
import {specialByIdSelector} from "../../_data/selectors";


const mapStateToProps = (state, props) => {
    const special = specialByIdSelector(state, parseInt(props.match.params.id));
    return {
        item: special,
        loading: selectorLoadingSpecial(state),
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        dispatch: dispatch,
    }
};
const SpecialItemContainer = connect(mapStateToProps, mapDispatchToProps)(SpecialItemComponent);
export default SpecialItemContainer;


// WEBPACK FOOTER //
// ./app/client/special/containers/SpecialItemContainer.tsx